"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = isMobileView => {
  const {
    fontFamily,
    basicFontSize
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const ccStudyYearSelectionStyle = (0, _react.useMemo)(() => {
    const ccStudyYearSelection = (0, _css.css)({
      fontSize: basicFontSize,
      fontFamily: fontFamily
    });
    const ccStudyYearSelectionAnchorBtn = (0, _css.css)({
      display: 'flex',
      alignItems: 'center',
      fontSize: basicFontSize,
      fontFamily: fontFamily,
      gap: '1rem'
    });
    const ccTitle = (0, _css.css)({
      fontsize: basicFontSize,
      fontWeight: 'bold',
      marginBottom: isMobileView ? 0 : pxToRem(3)
    });
    const ccYearOptions = (0, _css.css)({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    });
    const ccSemesterOptions = (0, _css.css)({
      marginTop: isMobileView ? pxToRem(20) : pxToRem(10)
    });
    const ccCustomRangeDates = (0, _css.css)({
      marginTop: isMobileView ? pxToRem(20) : pxToRem(10)
    });
    return {
      ccStudyYearSelection,
      ccStudyYearSelectionAnchorBtn,
      ccTitle,
      ccYearOptions,
      ccSemesterOptions,
      ccCustomRangeDates
    };
  }, [basicFontSize, fontFamily, isMobileView, pxToRem]);
  return {
    'cc-StudyYearSelection': ccStudyYearSelectionStyle.ccStudyYearSelection,
    'cc-StudyYearSelection__anchor-btn': ccStudyYearSelectionStyle.ccStudyYearSelectionAnchorBtn,
    'cc-StudyYearSelection__title': ccStudyYearSelectionStyle.ccTitle,
    'cc-StudyYearSelection__year-options': ccStudyYearSelectionStyle.ccYearOptions,
    'cc-StudyYearSelection__semester-options': ccStudyYearSelectionStyle.ccSemesterOptions,
    'cc-StudyYearSelection__custom-range-dates': ccStudyYearSelectionStyle.ccCustomRangeDates
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;